// extracted by mini-css-extract-plugin
export default {"dataSources":"DataSources_dataSources__Gxfcd","img":"DataSources_img__ZQdu0"};